import React, { useState, useRef, useEffect, useMemo } from "react";
import UploadPopup from "../../../../../../common/components/upload-file-popup/upload-file-popup";
import { uploadFileAttachmentsProps } from "./customer-view-details-view-attachment-info.props";
import { AlertComponent } from "../../../../../../common/components";
import { useManualSetLoading } from "../../../../../../common/hooks/loadUntilCompOfApi";
import { addCustomerAttachment } from "../../../../../../api/customer";

export type UploadFile = {
    id:string
    file: File
    name: string
    size: string
    progress: number
    status: 'pending' | 'uploading' | 'done' | 'error'
}


const UploadFileAttachment: React.FC<uploadFileAttachmentsProps> = ({
    selectedOption, setSelectedOption, customerId, fetchAttachments
}) => {
    const [alertMessage, setAlertMessage] = useState<string>("");
    const [alertType, setAlertType] = useState<"success" | "error">("success");
    const [alertOpen, setAlertOpen] = useState<boolean>(false);
    const [files, setFiles] = useState<UploadFile[]>([]);
    const [loading, setLoading] = useState(false)
    const handleAttach = () => {
        const actualFiles = files?.map((f) => f.file);
        handleFinalUpload(actualFiles); // Send only File[] to parent
    };

    const handleFinalUpload = async (files: File[]) => {
        setLoading(true)
        const formData = new FormData();
        files.forEach((file) => {
            formData.append("files", file); // or "file", depending on API
        });
        try {
            const response = await addCustomerAttachment(customerId, formData)
            if (response?.status === 201) {
                setAlertMessage(`${files?.length > 1 ? 'Files' : 'File'} uploaded successfully`);
                setAlertType("success");
                setSelectedOption("")
                fetchAttachments()
                setFiles([])

            }
        } catch (error: any) {
            setAlertMessage(error?.response?.data?.message || error?.response?.data?.error || "Something went wrong. Please try again later.");
            setAlertType("error");
        } finally {
            setLoading(false);
            setAlertOpen(true);
        }
    }

    const handleCancel = () => {
        setSelectedOption("")
        setFiles([])
    }
    const showLoading = useMemo(() => loading, [loading]);
    useManualSetLoading(showLoading);

    return (
        <>{selectedOption === "uploadFile" && <UploadPopup
            open={!!selectedOption}
            title="Attach File"
            onCancel={handleCancel}
            onOkay={handleAttach}
            buttonText="Attach"
            disable={true}
            files={files}
            setFiles={setFiles}
        />}
            <AlertComponent
                message={alertMessage}
                type={alertType}
                open={alertOpen}
                onClose={() => setAlertOpen(false)}
            />
        </>
    )
}

export default UploadFileAttachment;